import styled from 'styled-components';
import { CantFindYourDreamCarStyled } from '../CantFindYourDreamCarStyled';
export const CantFindYourDreamCarStyledAC = styled(CantFindYourDreamCarStyled)``;
